import { WordGuessPuzzleModel } from './word-guess-puzzle.model';

export class InitWordGuessPuzzle {
  static readonly type = '[WordGuessPuzzle] Init';
  constructor(public payload: WordGuessPuzzleModel) {}
}

export class PersistWordGuessState {
  static readonly type = '[WordGuessPuzzle] Persist user input';
  constructor(public payload: WordGuessPuzzleModel) {}
}
